import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserAuth } from "../../context/authContext";
import { clsx } from "clsx";
import toast from "react-hot-toast";
import {
  FiX,
  FiHome,
  FiBox,
  FiCpu,
  FiSend,
  FiLayers,
  FiLogOut,
  FiTrendingUp,
  FiPackage,
  FiPlusCircle,
} from "react-icons/fi";
import logo from "../assets/astra_hack_logo.png";

const HackSidebar = ({ onSidebarHide, showSidebar, activeId }) => {
  const [role] = useState(() => localStorage.getItem("role") || "");
  const [team] = useState(() => localStorage.getItem("team") || "");
  const { logout } = UserAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/");
    } catch (error) {
      toast.error("Failed to log out");
    }
  };

  const sidebarItems = [
    { id: "0", title: "Home", icon: <FiHome />, link: "/" },
    { id: "1", title: "Room Dashboard", icon: <FiLayers />, link: "/joinedhack" },
    {
      id: "create-transaction",
      title: "Create Transaction",
      icon: <FiPlusCircle />,
      link: "/createtransactionhack",
    },
    {
      id: "transactions",
      title: "Transactions",
      icon: <FiSend />,
      link: "/transactionhack",
    },
    { id: "2", title: "Explore Network", icon: <FiBox />, link: "/etherscanhack" },
    {
      id: "3",
      title: "Mempool",
      icon: <FiCpu />,
      link: "/mempoolhack",
      hidden: !(role === `${team}_miner`),
    },
    { id: "4", title: "Leaderboard", icon: <FiTrendingUp />, link: "/leaderboardhack" },
    { id: "5", title: "My Blocks", icon: <FiPackage />, link: "/hackblocks" },
  ].filter((item) => !item.hidden);

  return (
    <div
      className={clsx(
        "fixed inset-y-0 left-0 bg-[#0f111a]/80 backdrop-blur-xl border-r border-white/10 w-64 transition-transform duration-300 z-50",
        showSidebar ? "translate-x-0" : "-translate-x-full lg:translate-x-0"
      )}
    >
      <div className="p-6 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-gradient-to-tr from-primary to-secondary p-[2px]">
            <div className="w-full h-full rounded-full bg-background overflow-hidden relative">
              <img src={logo} alt="Logo" className="w-full h-full object-cover" />
            </div>
          </div>
          <span className="font-bold text-xl tracking-wide text-white">AstraHack</span>
        </div>
        <button
          onClick={onSidebarHide}
          className="lg:hidden p-2 text-text-muted hover:text-white transition-colors"
        >
          <FiX size={24} />
        </button>
      </div>

      <nav className="mt-8 px-4 space-y-2">
        {sidebarItems.map((item) => (
          <button
            key={item.id}
            onClick={() => navigate(item.link)}
            className={clsx(
              "w-full flex items-center gap-4 px-4 py-3 rounded-xl transition-all group",
              activeId === item.id
                ? "bg-primary text-white shadow-lg shadow-primary/20"
                : "text-text-muted hover:bg-white/5 hover:text-white"
            )}
          >
            <span
              className={clsx(
                "text-xl transition-colors",
                activeId === item.id ? "text-white" : "text-text-muted group-hover:text-primary"
              )}
            >
              {item.icon}
            </span>
            <span className="font-medium">{item.title}</span>
          </button>
        ))}
      </nav>

      <div className="absolute bottom-6 left-4 right-4">
        <button
          onClick={handleLogout}
          className="w-full flex items-center gap-4 px-4 py-3 rounded-xl text-red-400 hover:bg-red-400/10 hover:text-red-300 transition-all group font-medium border border-red-500/20"
        >
          <FiLogOut className="text-xl group-hover:scale-110 transition-transform" />
          <span>Logout</span>
        </button>
      </div>
    </div>
  );
};

export default HackSidebar;
